import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import QueryString from 'qs';
import { toast } from 'react-toastify';
import moment from 'moment';
import { ClipLoader } from 'react-spinners';

import PageWithCard from '../../components/infrastructure/PageWithCard';
import { authAxiosInstance } from '../../utils/axiosConfig';
import TableWithHeadingAndSearch from '../../components/Table/TableWithHeadingAndSearch';
import PaginationClassic from '../../components/pagination/PaginationClassic';
import telephoneLogo from '../../images/telephone.png';
import telephoneLogo2 from '../../images/telephone2.png';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import { MessageSquare, PhoneIncoming, PhoneOutgoing } from 'react-feather';
import TableAndSearchCustom from '../../components/Table/TableAndSearchCustom';

const PhoneBook = () => {
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [phonebook, setPhonebook] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    console.log('phonebook', phonebook);
    const [linkOption, setLinkOption] = useState({});
    const [openMessageBox, setOpenMessageBox] = useState(false);
    const [scrollY, setScrollY] = useState(0);

    const dispatch = useDispatch();

    const fetchPhonebook = async (page = 1,search = '') => {
        try {
            setLoading(true);
            const payload = {
                page,
                occurredDate: {
                    $gte: moment().subtract(2, 'days').startOf('day').valueOf(),
                    $lte: moment().endOf('day').valueOf(),
                },
            };
            console.log('payload',payload)
            if (search || search !== '') {
                payload['search'] = search;
            }
            console.log('fetch payload', payload);
            const string = QueryString.stringify(payload);
            const resp = await authAxiosInstance.get(`/phonebook?${string}`);
            console.log('resp', resp);
            setPhonebook(resp?.data?.data);
            setLoading(false);
        } catch (error) {
            console.log('Error', error);
            toast.error('Failed to fetch phonebook data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPhonebook(page);
    }, [page]);

    useEffect(() => {
        const handelScroll = () => {
            setScrollY(window.scrollY);
        };
        window.addEventListener('scroll', handelScroll);

        return () => {
            window.removeEventListener('scroll', handelScroll);
        };
    }, []);

    const replacePlaceholder = (inputStr, replacementArray) => {
        let replacedStr = inputStr;
        for (let i = 0; i < replacementArray.length; i++) {
            replacedStr = replacedStr.replace('{#var#}', replacementArray[i]);
        }
        return replacedStr;
    };

    const debouncedSearch = useCallback(
        _.debounce(async (search) => {
            const initialPage = 1;
            fetchPhonebook(initialPage,search);
        }, 300),
        []
    );

    const groupByDate = (data) => {
        const grouped = data?.reduce((acc, ele) => {
            const occurredMoment = moment(
                ele.occurredAt,
                'MMMM D, YYYY [at] hh:mma'
            );
            const isToday = occurredMoment.isSame(moment(), 'day');
            const isYesterday = occurredMoment.isSame(
                moment().subtract(1, 'days'),
                'day'
            );
            const groupTitle = isToday
                ? 'Today'
                : isYesterday
                  ? 'Yesterday'
                  : occurredMoment.format('DD/MM/YYYY');

            if (!acc[groupTitle]) {
                acc[groupTitle] = [];
            }
            acc[groupTitle].push(ele);

            return acc;
        }, {});

        return Object.entries(grouped);
    };
    const calculateCallStatus = (status, time,phoneNumber) => {
        if (status === 'missed' && time === 0) {
            return (
                <PhoneIncoming
                    className="cursor-pointer"
                    color="#E71010"
                    style={{ fill: '#E71010' }}
                    size={20}
                    onClick={async (e) => {
                        e.stopPropagation();
                        try {
                            const resp = await authAxiosInstance.post(
                                `/purchase-orders/directPushCall`,
                                { phoneNumber: phoneNumber.slice(-10) }
                            );
                            console.log('resp call', resp);
                            if (resp?.data?.success) {
                                toast.success('Call Placed');
                            }
                        } catch (error) {
                            console.log('Error', error);
                            toast.error('Failed to call this number');
                        }
                    }}
                />
            );
        } else if (status === 'outgoing' && time === 0) {
            return (
                <img
                    src={telephoneLogo}
                    alt="telephone"
                    className="w-[24px] cursor-pointer"
                    onClick={async (e) => {
                        e.stopPropagation();
                        try {
                            const resp = await authAxiosInstance.post(
                                `/purchase-orders/directPushCall`,
                                { phoneNumber: phoneNumber.slice(-10) }
                            );
                            console.log('resp call', resp);
                            if (resp?.data?.success) {
                                toast.success('Call Placed');
                            }
                        } catch (error) {
                            console.log('Error', error);
                            toast.error('Failed to call this number');
                        }
                    }}
                />
            );
        } else if (status === 'outgoing' && time > 0) {
            return (
                <img
                    src={telephoneLogo2}
                    alt="telephone2"
                    className="w-[24px] cursor-pointer"
                    onClick={async (e) => {
                        e.stopPropagation();
                        try {
                            const resp = await authAxiosInstance.post(
                                `/purchase-orders/directPushCall`,
                                { phoneNumber: phoneNumber.slice(-10) }
                            );
                            console.log('resp call', resp);
                            if (resp?.data?.success) {
                                toast.success('Call Placed');
                            }
                        } catch (error) {
                            console.log('Error', error);
                            toast.error('Failed to call this number');
                        }
                    }}
                />
            );
        } else {
            return (
                <PhoneIncoming
                    className="cursor-pointer"
                    color="#347D2F"
                    style={{ fill: '#347D2F' }}
                    size={20}
                    onClick={async (e) => {
                        e.stopPropagation();
                        try {
                            const resp = await authAxiosInstance.post(
                                `/purchase-orders/directPushCall`,
                                { phoneNumber: phoneNumber.slice(-10) }
                            );
                            console.log('resp call', resp);
                            if (resp?.data?.success) {
                                toast.success('Call Placed');
                            }
                        } catch (error) {
                            console.log('Error', error);
                            toast.error('Failed to call this number');
                        }
                    }}
                />
            );
        }
    };

    const cols = [
        {
            Header: 'Phone',
            accessor: 'phone',
            Cell: ({ row }) => {
                return (
                    <div className="flex flex-col">
                        <span>{row?.original?.phone.slice(-10)}</span>
                        {/* <span className="text-[11px]">
                            {row?.original?.name}
                        </span> */}
                    </div>
                );
            },
            cellStye: {
                width: '20%',
            },
        },
        {
            Header: 'Name',
            accessor: 'name',
            Cell: ({ row }) => {
                return (
                    <div className="flex flex-col">
                        {/* <span>{row?.original?.phone}</span> */}
                        <span className="text-[12px]">
                            {row?.original?.name}
                        </span>
                    </div>
                );
            },
            cellStye: {
                width: '40%',
            },
        },
        // {
        //     Header: 'Phone No.',
        //     accessor: 'phone',
        // },
        {
            Header: 'Time',
            accessor: 'occurredAt',
            Cell: ({ row }) => {
                const occurredMoment = moment(
                    row.original.occurredAt,
                    'MMMM D, YYYY [at] h:mma'
                );
                const date = occurredMoment.format('DD-MM');
                const time = occurredMoment.format('HH:mm');
                return (
                    <div className="flex flex-col">
                        {/* <span>{date}</span> */}
                        <span>{time}</span>
                        <span className="hidden">
                            {row?.original?.occurredAt}
                        </span>
                    </div>
                );
            },
            cellStye: {
                width: '15%',
            },
        },
        {
            Header: 'Type',
            accessor: 'callStatus',
            Cell: ({ row }) => {
                return (
                    <div className="flex flex-col">
                        <span>
                            {calculateCallStatus(
                                row?.original?.callStatus,
                                row?.original?.callDuration,
                                row?.original?.phone
                            )}
                        </span>
                        <span className="hidden">
                            {row?.original?.callStatus}
                        </span>
                    </div>
                );
            },
            cellStye: {
                width: '10%',
            },
        },
        // {
        //     Header: 'Duration',
        //     accessor: 'callDuration',
        // },
        {
            Header: ' ',
            Cell: ({ row }) => {
                return (
                    <span
                        className="cursor-pointer"
                        onClick={async (e) => {
                            e.stopPropagation();
                            const obj = {
                                phone: row?.original?.phone,
                            };
                            const respData = await authAxiosInstance.post(
                                `/api/ifttt/manualText`,
                                obj
                            );
                            console.log('respData', respData);
                            if (respData?.data?.success) {
                                toast.success(`${respData?.data?.message}`);
                            }
                        }}
                    >
                        {/* <img
                            src={messageLogo}
                            alt="messageLogo"
                            className="w-[25px] h-[25px]"
                        /> */}
                        <MessageSquare color="#3F51B5" />
                    </span>
                );
            },
            cellStye: {
                width: '15%',
            },
        },
    ];

    const phonebookData = useMemo(() => {
        if (phonebook && phonebook?.docs?.length) {
            return groupByDate(phonebook?.docs);
        } else return [];
    }, [phonebook]);
    console.log('phoneBook data==>>>', phonebookData);
    const handleChange = (e) =>{
        const value = e.target.value;
        setSearchTerm(value)
        debouncedSearch(value)

    }
    return (
        // <PageWithCard heading="Phonebook">
        //     <TableWithHeadingAndGlobalSearch
        //         columns={cols}
        //         data={phonebookData}
        //         loading={loading}
        //         searchFunction={debouncedSearch}
        //     />
        //     <PaginationClassic
        //         paginationDetails={phonebook}
        //         setPage={setPage}
        //     />
        // </PageWithCard>
        <div className="p-4 w-fill md:w-1/2 text-center m-auto ">
            <h1 className="text-center text-xl font-semibold mb-4">
                Phonebook
            </h1>
            
            <div className="max-w-xl mb-5">
            <div className="relative">
                <input
                    className={`form-input w-full pl-9 py-3 focus:border-slate-300 rounded-md`}
                    type="search"
                    placeholder={'Search Phonebook...'}
                    onChange={handleChange}
                />
                <button
                    className="absolute inset-0 right-auto group"
                    aria-label="Search"
                >
                    <svg
                        className="w-4 h-4 shrink-0 fill-current text-slate-400 group-hover:text-slate-500 ml-3 mr-2"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
                        <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z" />
                    </svg>
                </button>
            </div>
        </div>
            { 
                phonebookData.map(([dateTitle, values]) => (
                    <div className="" key={dateTitle}>
                        <div className="sticky top-[63px] bg-gray-200 text-gray-500 text-sm px-1 mx-auto z-60 text-center w-[15%] rounded-lg">
                            {dateTitle}
                        </div>
                        <TableAndSearchCustom
                            columns={cols}
                            data={values}
                            loading={loading}
                            searchFunction={debouncedSearch}
                        />
                    </div>
                ))
            }
            {/* <TableWithHeadingAndGlobalSearch
                columns={cols}
                data={phonebookData}
                loading={loading}
                searchFunction={debouncedSearch}
            /> */}
            <PaginationClassic
                paginationDetails={phonebook}
                setPage={setPage}
            />
        </div>
    );
};

export default PhoneBook;
